import { useState, useEffect, useCallback, useRef } from 'react';
import userServices from '../services/userServices';
import logger from '../utils/logger';

export const useSettings = () => {
  const [adminSettings, setAdminSettings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const isLoadingRef = useRef(false);


  const getSettings = async () => {
    try {
      const response = await userServices.getAdminSettings();
      logger("log", "getAdminSettingsRes", response);
      setAdminSettings(response.data);
    } catch (error) {
      setError(error.message);
    }
  };

  useEffect(() => {
    getSettings();
  }, []);

  return {
    getSettings,
    adminSettings,
  };
};
